import { Controller } from '@hotwired/stimulus'
import { isDismissed, rememberDismissal } from '../utils'

const COOKIE = 'app_download_dismissed'

// Connects to data-controller="app-download"
// Opens the "download the app" bottom sheet. The server renders it only until it has
// been closed (ApplicationHelper#app_download_sheet?): closing it sets the cookie that
// also lets Safari's app banner take over.
export default class extends Controller {
  static outlets = ['dialog']

  dialogOutletConnected(dialog) {
    // A page restored from the Turbo cache can still hold the sheet after it was closed.
    if (isDismissed(COOKIE)) return

    // Let the page settle before sliding the sheet up.
    this.timeout = setTimeout(() => dialog.show(), 1000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  // Called on `dialog:dismiss` (cross, tap outside, Escape, back gesture) and on the phone's
  // store badge; not when Turbo closes the sheet by leaving the page, so that it comes back on
  // the next one.
  dismiss() {
    rememberDismissal(COOKIE)
  }
}
